import { makeStyles } from "@material-ui/core/styles";
import styled from "styled-components";

import { colors } from "../../../../components/theme";

export const useStyles = makeStyles((theme) => ({
  headerStyle: {
    backgroundColor: colors.white,
    fontSize: "15px",
  },
}));

export const WrapperParagraph = styled.div`
  width: 100%;
  padding: 20px;
  border-radius: 4px;
  display: inline-block;
  background-color: white;
  overflow-y: hidden;
`;
export const Title = styled.h4`
  color: #0076ff;
  margin: 0 auto;
  text-align: left;
  font-weight: 900;
  position: absolute;
`;
export const ShowContent = styled.div`
  background-color: ${colors.white};
  border-radius: 6px;
  padding: 2px;
  overflow: hidden;
  line-height: 0.5;
`;

export const Container = styled.div`
  width: 100%;
  padding: 5px;
  background-color: ${colors.white};
  position: relative;
  height: auto;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ButtonContainerTools = styled.section`
  display: flex;
  width: 100%;
  height: 30px;
  justify-content: space-between;
  margin-top: 15px;
`;
